const MainWrapperBlock = ({ children, ...props }) => (
  <main 
  className='center-content flex-grow' 
  {...props}
  >
    {children}
  </main>
);

export default MainWrapperBlock;